import { render, staticRenderFns } from "./ModalHistoricoMultiplo.vue?vue&type=template&id=cdb52f74&"
import script from "./ModalHistoricoMultiplo.vue?vue&type=script&lang=js&"
export * from "./ModalHistoricoMultiplo.vue?vue&type=script&lang=js&"
import style0 from "./ModalHistoricoMultiplo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports